import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class DicOperatorApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'dicOperator'
    }

    /**
     * 查询列表
     * @returns 
     */
    public getOperatorList(){
        return this.send({},"getOperatorList",Methods.GET)
    }

    /**
     * 保存或更新
     * @param param 
     * @returns 
     */
    public updateOperator(param){
        return this.send(param,"update",Methods.POST)

    }

    /**
     * 删除
     * @param ids 
     */
    public deleteOperator(ids){
        return this.send({},"delete?ids="+ids,Methods.POST)
    }


   
}